'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactIntl = require('react-intl');

var useFormatMessage = function () {
    var intl = reactIntl.useIntl();
    return function (message, values) {
        return intl.formatMessage(message, values);
    };
};

var useFormatDate = function () {
    var intl = reactIntl.useIntl();
    return function (value, options) {
        return intl.formatDate(value, options);
    };
};

var useFormatTime = function () {
    var intl = reactIntl.useIntl();
    return function (value, options) {
        return intl.formatTime(value, options);
    };
};

var useFormatRelativeTime = function () {
    var intl = reactIntl.useIntl();
    return function (value, unit, options) {
        return intl.formatRelativeTime(value, unit, options);
    };
};

var useFormatNumber = function () {
    var intl = reactIntl.useIntl();
    return function (value, options) {
        return intl.formatNumber(value, options);
    };
};

var useFormatPlural = function () {
    var intl = reactIntl.useIntl();
    return function (value, options) {
        return intl.formatPlural(value, options);
    };
};

var useFormatList = function () {
    var intl = reactIntl.useIntl();
    return function (value, options) {
        return intl.formatList(value, options);
    };
};

Object.defineProperty(exports, 'IntlProvider', {
  enumerable: true,
  get: function () {
    return reactIntl.IntlProvider;
  }
});
exports.useFormatDate = useFormatDate;
exports.useFormatList = useFormatList;
exports.useFormatMessage = useFormatMessage;
exports.useFormatNumber = useFormatNumber;
exports.useFormatPlural = useFormatPlural;
exports.useFormatRelativeTime = useFormatRelativeTime;
exports.useFormatTime = useFormatTime;
